import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import UploadSKRepository from "../Repositories/UploadSKRepository";

class UploadSKBloc {
  uploadSkChannel = new Subject();
  detailChannel = new Subject();
  rankChanel = new Subject();
  signatoryChannel = new Subject();
  documentTypeChanel = new Subject();
  downloadSPMTChannel = new Subject();
  downloadContractChannel = new Subject();
  repository = new UploadSKRepository();

  constructor() {
    this.uploadSkChannel.next({ status: apiResponse.INITIAL });
    this.detailChannel.next({ status: apiResponse.INITIAL });
    this.rankChanel.next({ status: apiResponse.INITIAL });
    this.signatoryChannel.next({ status: apiResponse.INITIAL });
    this.documentTypeChanel.next({ status: apiResponse.INITIAL });
    this.downloadSPMTChannel.next({ status: apiResponse.INITIAL });
    this.downloadContractChannel.next({ status: apiResponse.INITIAL });
  }

  fetchDetail = async (query) => {
    try {
      this.detailChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDetail(query)
        .then((result) => {
          this.detailChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.detailChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchUploadSk = async (query) => {
    try {
      this.uploadSkChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchUploadSk(query)
        .then((result) => {
          this.uploadSkChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.uploadSkChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchRank = async (query) => {
    try {
      this.rankChanel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRank(query)
        .then((result) => {
          this.rankChanel.next({ status: apiResponse.COMPLETED, data: result });
        })
        .catch((error) => {
          this.rankChanel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchSignatory = async (query) => {
    try {
      this.signatoryChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchSignatoryOfficial(query)
        .then((result) => {
          this.signatoryChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.signatoryChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchDocumentType = async (query) => {
    try {
      this.documentTypeChanel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDocumentType(query)
        .then((result) => {
          this.documentTypeChanel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.documentTypeChanel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchDownloadSPMT = async (query) => {
    try {
      this.downloadSPMTChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDownloadSPMT(query)
        .then((result) => {
          this.downloadSPMTChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.downloadSPMTChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchDownloadContract = async (query) => {
    try {
      this.downloadContractChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDownloadContract(query)
        .then((result) => {
          this.downloadContractChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.downloadContractChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };
}

export default UploadSKBloc;
